export enum VisitationFormatEnum {
    NotSelected = 0,
    InPerson = 1,
    Virtual = 2
}